"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var e_1, _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = initKonamiListener;
var core_1 = require("@eeaas/core");
var eggindex_1 = require("../eeaas/eggindex");
var excuse_1 = __importDefault(require("../eeaas/excuse"));
var koco = __importStar(require("../ko-co"));
// Optional: safely extend Array prototype
Array.prototype.random = function () {
    return this[Math.floor(Math.random() * this.length)];
};
// Initialize Konami code support
koco.addSupportForTheKonamiCode({});
// Initialize Eeaas and register eggs
var eeaas = (0, core_1.initializeEeaas)();
try {
    for (var eggs_1 = __values(eggindex_1.eggs), eggs_1_1 = eggs_1.next(); !eggs_1_1.done; eggs_1_1 = eggs_1.next()) {
        var egg = eggs_1_1.value;
        eeaas.register(egg);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (eggs_1_1 && !eggs_1_1.done && (_a = eggs_1.return)) _a.call(eggs_1);
    }
    finally { if (e_1) throw e_1.error; }
}
function initKonamiListener() {
    var title = document.title;
    var pageHeader = document.querySelector(".page-header > h2");
    var originalpageHeaderText = (pageHeader === null || pageHeader === void 0 ? void 0 : pageHeader.textContent.trim()) || "";
    function toggleUnicorn() {
        var e_2, _a, e_3, _b;
        console.log("🦄 Konami Code triggered!");
        var unicorn = eeaas.get("unicorncursor");
        if (!unicorn) {
            console.warn("Unicorn cursor not found");
            return;
        }
        if (unicorn.isEnabled) {
            unicorn.stop();
            try {
                for (var _c = __values(eeaas.getAll()), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var e = _d.value;
                    e.stop();
                    e.disable();
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
            document.title = title;
            if (pageHeader)
                pageHeader.textContent = originalpageHeaderText;
        }
        else {
            try {
                for (var _e = __values(eeaas.getAll()), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var e = _f.value;
                    e.enable();
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_3) throw e_3.error; }
            }
            unicorn.start();
            document.title = "🦄 " + excuse_1.default.random();
            if (pageHeader)
                pageHeader.textContent = "🦄 " + excuse_1.default.random();
        }
    }
    window.addEventListener("konamicode", toggleUnicorn);
    window.egg = toggleUnicorn;
}
